module.exports = __webpack_public_path__ + "static/media/mensajes.979e4c3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/mensajes.svg
// module id = 1795
// module chunks = 0